import axios from 'axios'
import { Message } from 'element-ui'

// 开发环境通过 devServer 代理转发，生产环境直连配置的 HTTPS 服务。
export const API_HOST = process.env.NODE_ENV === 'development'
  ? '/ServerApi'
  : 'https://sjbgcy.czt.zj.gov.cn/ServerApi'
const service = axios.create({ baseURL: API_HOST, timeout: 30000, withCredentials: false })

export async function postJson(url, data, config) {
  try {
    var response = await service.post(url, data, config)
    var body = response.data || {}
    if (body.Result !== true || Number(body.Code) !== 200) {
      var message = body.Info || '请求失败，请稍后重试'
      Message({ showClose: true, message: message, type: 'error' })
      var error = new Error(message)
      error.code = Number(body.Code) || -1
      error.info = message
      throw error
    }
    return body.Data
  } catch (error) {
    if (error && error.info) throw error
    Message({ showClose: true, message: '网络异常，请稍后重试', type: 'error' })
    throw new Error('网络异常，请稍后重试')
  }
}

export default service
